import script from "./WidgetCatalogDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetCatalogDrawer.vue?vue&type=script&setup=true&lang=js"

import "./WidgetCatalogDrawer.vue?vue&type=style&index=0&id=7df1b628&scoped=true&lang=css"
import "./WidgetCatalogDrawer.vue?vue&type=style&index=1&id=7df1b628&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df1b628"]])

export default __exports__